import {
  UPDATE_CHECK_ERROR,
  UPDATE_CHECK_DATA,
  UPDATE_SCAN_BACK_RESPONSE,
  UPDATE_SCAN_FRONT_RESPONSE,
  CLEAN_CHECK_STATE,
  SET_CHECK_REQUEST_LOADING,
  CLEAN_CHECK_SCAN_ERROR,
  UPDATE_RESERVATION_RESPONSE,
  UPDATE_BACK_PHOTO,
  UPDATE_FRONT_PHOTO,
  SHOW_CONFIRM_AMOUNT_DIALOG,
  SET_CHECK_SCAN_PAYMENT_CONFIRMED,
  PROCESS_FRONT_CHECK_SCAN_IMAGE,
  PROCESS_BACK_CHECK_SCAN_IMAGE,
  SET_DUPLICATE_ORDER_ID,
} from "../../actions/actionTypes/check/index";
import { CheckState } from "../../store/check/type";

const initialState: CheckState = {
  checkData: {
    photoFront: "",
    photoBack: "",
    checkType: "",
    amount: 0.00,
    accountNumber: "",
    routingNumber: "",
    checkNumber: ""
  },
  frontResponse: null,
  backResponse: null,
  reservationResponse: null,
  error: null,
  warning: null,
  isLoading: false,
  showConfirmAmountDialog: false,
  confirmed: false,
  duplicatedDate: null,
  processFrontCheckScanImage: false,
  processBackCheckScanImage: false,
};

export function check(state = initialState, action: any): CheckState {
  switch (action.type) {
    case UPDATE_CHECK_DATA: {
      return {
        ...state,
        checkData: action.payload,
      };
    }
    case UPDATE_SCAN_FRONT_RESPONSE: {
      return {
        ...state,
        frontResponse: action.payload,
      };
    }
    case UPDATE_SCAN_BACK_RESPONSE: {
      return {
        ...state,
        backResponse: action.payload,
      };
    }
    case UPDATE_RESERVATION_RESPONSE: {
      return {
        ...state,
        reservationResponse: action.payload,
      };
    }
    case UPDATE_CHECK_ERROR: {
      return {
        ...state,
        error: action.payload,
      };
    }
    case CLEAN_CHECK_SCAN_ERROR: {
      return {
        ...state,
        error: null,
      };
    }
    case SET_CHECK_REQUEST_LOADING: {
      return {
        ...state,
        isLoading: action.payload,
      };
    }
    case UPDATE_FRONT_PHOTO: {
      return {
        ...state,
        checkData: {
          ...state.checkData,
          photoFront: action.payload,
        },
      };
    }
    case UPDATE_BACK_PHOTO: {
      return {
        ...state,
        checkData: {
          ...state.checkData,
          photoBack: action.payload,
        },
      };
    }
    case CLEAN_CHECK_STATE: {
      return initialState;
    }
    case SHOW_CONFIRM_AMOUNT_DIALOG: {
      return {
        ...state,
        showConfirmAmountDialog: action.payload,
      };
    }
    case SET_CHECK_SCAN_PAYMENT_CONFIRMED: {
      return {
        ...state,
        confirmed: action.payload,
      };
    }
    case SET_DUPLICATE_ORDER_ID: {
      return {
        ...state,
        duplicatedOrderId: action.payload,
      }
    }
    case PROCESS_FRONT_CHECK_SCAN_IMAGE: {
      return {
        ...state,
        processFrontCheckScanImage: action.payload,
      };
    }
    case PROCESS_BACK_CHECK_SCAN_IMAGE: {
      return {
        ...state,
        processBackCheckScanImage: action.payload,
      };
    }
    default:
      return state;
  }
}
